<template>
    <div class="process-task-select-pop">
        <div class="choose-enterprise-body">
            <el-container class="companySelectPop">
                <el-transfer 
                    :titles="['待选任务列表', '已选任务列表']"
                    v-model="selectItems" 
                    :data="data"></el-transfer>
            </el-container>
        </div>
        <div class="choose-enterprise-btn">
            <el-button type="info" @click="cancelClick">取消</el-button> 
            <el-button type="primary" @click="confirmClick">确定</el-button> 
        </div>
    </div>
</template>
<script>
import {getTaskFileAuthViewList, saveTaskFileAuthViewConfig, getProcessInstancesDetail, getAllUserTask} from '@/data-model';
export default {
    data () {
        return {
            processInstanceDetail: {},
            data: [],
            selectItems: []
        };
    },
    props: {
        processInstanceId: {
            type: String,
            default: ''
        },
        fileId: {
            type: String,
            default: ''
        }

    },
    created () {
        this._initPage();
    },
    methods: {
        async _initPage () {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.data = [];
            this.processInstanceDetail = await getProcessInstancesDetail(this.processInstanceId);
            // console.log(this.subInstances);
            let tasks = await getAllUserTask(this.processInstanceDetail.id, this.processInstanceDetail.processServiceId, null, this.processInstanceDetail.deploymentId);
            for (var i = 0; i < tasks.length; i++) {
                this.data.push({key: tasks[i].taskId, label: tasks[i].taskName});
            }
            // console.log(this.data);
            await this.getTaskFileAuthViewList();
            loading.close();
        },
        async getTaskFileAuthViewList () {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let param = {};
            param.processInstanceId = this.processInstanceId;
            param.fileId = this.fileId;
            let data = await getTaskFileAuthViewList(param);
            if (data.taskIdList) {
                this.selectItems = data.taskIdList;
            }
            loading.close();
        },
        async confirmClick () {
            let param = {};
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            param.processInstanceId = this.processInstanceId;
            param.fileId = this.fileId;
            param.taskId = this.selectItems.join(',');
            await saveTaskFileAuthViewConfig(param);
            loading.close();
            this.$emit('confirm', param);
        },
        cancelClick () {
            this.$emit('cancel');
        }
    }
};
</script>

<style lang="less">
    .process-task-select-pop{
        .choose-enterprise-body{
            .companySelectPop {
                height: 365px;
                .el-header {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .el-main {
                    padding: 0;
                }
        
                .el-aside {
                    border-right: 1px solid #dcdfe6;
                }
            }
        }
        .choose-enterprise-btn{
            text-align: right;
            padding-right: 20px;
            position: relative;
            top: 20px;
            margin: 10px 0px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/ProcessTaskSelectPop/ProcessTaskSelectPop.vue